import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IMenuFilter } from '@nimbus-library/features/menu';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';

export class TeamFilter implements IMenuFilter {
  public constructor(
    private readonly store: Store,
    private readonly authenticationService: IAuthenticationService,
    private readonly permissionManagerService: IPermissionManagerService,
  ) {}

  public validate$(): Observable<boolean> {
    return this.permissionManagerService.getBelongedTeamIds$().pipe(map((teamIds) => teamIds && teamIds.length > 0));
  }
}
